import { IconButton, Stack } from "@altimateai/lego";
import { Card, CardContent } from "@altimateai/lego";
import styles from "./styles.module.scss";
import AutoExpansionPopover from "./AutoExpansionPopover";
import { InfoCircleIcon } from "../../../assets/icons";
import { createPortal } from "react-dom";
import { useLineageContext } from "../context/LineageProvider";

const ExpandWithConfidenceCard = () => {
  const {
    state: { selectedColumn, confidence, aiEnabled },
  } = useLineageContext();
  const expandContainer = document.getElementById("expand-container");
  if (!expandContainer) {
    return null;
  }
  return createPortal(
    <Card className={styles.menu_card_container}>
      <CardContent className={`${styles.menu_card} pt-4`}>
        <Stack direction="row" gap="sm">
          <AutoExpansionPopover />
          {aiEnabled && selectedColumn?.name && confidence.confidence === "low" && (
            <>
              <div className={styles.verticle_divider} />
              <Stack direction="row" gap="xxs" align="center">
                <div>Confidence</div>
                <IconButton
                  title={
                    "Depending on the SQL dialect and complexity of queries, " +
                    "there may be situations where we are not completely " +
                    "confident about the lineage shown in this view"
                  }
                  id="confidence"
                >
                  <InfoCircleIcon />
                </IconButton>
                <div className={styles.low_confidence}>Low</div>
              </Stack>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>,
    expandContainer
  );
};

export default ExpandWithConfidenceCard;
